import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'classnames';
import styles from './HeaderEquipmentSeparator.module.scss';
export const HeaderEquipmentSeparator = ({ isFeatureFlag, size }) => {
    return (_jsx("div", { slot: "custom", className: cx(styles['separator'], {
            [styles['separator__isheader']]: isFeatureFlag && size == 'md',
            [styles['separator__isbanner']]: isFeatureFlag && size == 'lg'
        }) }));
};
